import useAuth from '@/context/AuthContext';
import { TypeProduct } from '@/core/generated-types';
import { isProductEnabled } from '@/utils/helpers';
import useSubscriptions from '@/context/SubscriptionContext';
import { useEffect, useState } from 'react';

export function useProductValidations(product?: TypeProduct | null) {
  const [isEnabled, setIsEnabled] = useState(false);

  const validations = product?.fields?.validations || [];
  const { user } = useAuth();
  const { data: subscriptionData = {} } = useSubscriptions();
  const _isEnabled = isProductEnabled(validations, subscriptionData, user);

  useEffect(() => {
    setIsEnabled(_isEnabled);
  }, [_isEnabled]);

  return isEnabled;
}
